<template>
  <a href="#" class="list-group-item list-group-item-action bg-light border-0">
    <div class="d-flex align-items-start">
      <img
        src="@/assets/avatar.jpg"
        class="rounded-circle mr-1"
        alt="Vanessa Tucker"
        width="40"
        height="40"
      />
      <div class="flex-grow-1 ml-3">Taha Malaldır</div>
      <div class="badge bg-info my-auto">5</div>
    </div>
  </a>
</template>

<script>
export default {};
</script>

<style></style>
